import React from "react";
import AuthorizationCheck from "../auth/authorizationCheck";
import Utility from "../utilities/utility";
import ShipmentService from "../services/shipping";

class GenerateShipmentUniqueNumbers extends React.Component {

    constructor(props) {
        super(props);

        this.shipmentService = new ShipmentService();

        this.state = {
            loading: false,
            result: null
        };
    }

    generateShipmentUniqueNumbers = async () => {
        try {
            this.setState({
                loading: true,
                result: null,
                currentUserRole: ''
            });

            const response = await this.shipmentService.generateShipmentUniqueNumbers();
            const result = await response.json();

            if (!response.ok) {
                Utility.showAlertWithId(
                    "errorHolder",
                    result.message || "Impossible de générer les numéros des expéditions",
                    "danger",
                    true
                );

                this.setState({ loading: false });
                return;
            }

            this.setState({
                loading: false,
                result: result
            });

            Utility.showAlertWithId(
                "errorHolder",
                "Numéros d'expédition générés avec succès",
                "success",
                true
            );

        } catch (error) {
            console.log(error);

            this.setState({ loading: false });

            Utility.showAlertWithId(
                "errorHolder",
                "Impossible de générer les numéros des expéditions",
                "danger",
                true
            );
        }
    }

     setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    render() {
        return (
            <div className="container mt-4">

                <AuthorizationCheck accessLevel="SUPER-ADMIN" userRole={this.setRole} />

                <div id="errorHolder"></div>

                <div className="card shadow-sm">
                    <div className="card-header bg-info text-white">
                        <h5 className="mb-0">
                            Générer les numéros uniques des expéditions
                        </h5>
                    </div>

                    <div className="card-body">
                        <p>
                            Cette action va générer un numéro unique pour toutes les expéditions
                            existantes qui n'ont pas encore de numéro.
                        </p>

                        <button
                            className="btn btn-primary"
                            onClick={this.generateShipmentUniqueNumbers}
                            disabled={this.state.loading}
                        >
                            {this.state.loading ? "Génération en cours..." : "Générer les numéros"}
                        </button>

                        {this.state.result && (
                            <div className="alert alert-success mt-4">
                                <strong>Terminé.</strong>
                                <br />
                                Expéditions mises à jour : {this.state.result.updated}
                                <br />
                                {this.state.result.message}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default GenerateShipmentUniqueNumbers;
